module.exports = __webpack_public_path__ + "img/Hypoxia-GBM_GSE194329.d2db2a72.png";